export const COLOR_MODE_STORAGE_KEY = 'crowpeaks-color-mode';

export type ColorMode = 'light' | 'dark';

export function getSystemColorMode(): ColorMode {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function readStoredColorMode(): ColorMode | null {
  const raw = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
  if (raw === 'light' || raw === 'dark') {
    return raw;
  }
  return null;
}

export function resolveColorMode(stored: ColorMode | null): ColorMode {
  return stored ?? getSystemColorMode();
}

export function applyColorModeToDocument(mode: ColorMode): void {
  document.documentElement.setAttribute('data-theme', mode);
  document.documentElement.style.colorScheme = mode;
}

export function writeStoredColorMode(mode: ColorMode): void {
  localStorage.setItem(COLOR_MODE_STORAGE_KEY, mode);
}
